import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

// Définition des thèmes
const lightTheme = {
  dark: false,
  colors: {
    primary: '#2196F3',
    secondary: '#424242',
    accent: '#FF4081',
    error: '#F44336',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    'on-background': 'rgba(0, 0, 0, 0.87)',
    'on-surface': 'rgba(0, 0, 0, 0.87)',
  }
}

const darkTheme = {
  dark: true,
  colors: {
    primary: '#90CAF9',
    secondary: '#616161',
    accent: '#FF80AB',
    error: '#EF5350',
    info: '#42A5F5',
    success: '#66BB6A',
    warning: '#FFCA28',
    'on-background': 'rgba(255, 255, 255, 0.87)',
    'on-surface': 'rgba(255, 255, 255, 0.87)',
  }
}

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      lightTheme,
      darkTheme,
    },
  },
})